import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { getInformationForDay } from '@/domain/termine/shared/utils/dateValidations';
import { getDaysStyle } from '@/domain/termine/shared/utils/getDaysStyle';
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { buttonVariants } from '@e2n/ui';
import { Termin } from '@/domain/termine/shared/types/Termin';
import { faPlusLarge } from '@fortawesome/pro-regular-svg-icons';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { buildCreateTerminUrl } from '@/domain/termine/shared/utils/urlBuilder';

interface DayCellHeaderProps {
  day: dayjs.Dayjs;
  termine: Termin[];
}

export function DayCellHeader({ day, termine }: DayCellHeaderProps) {
  const { t } = useTranslation();
  const { monthDate } = useCalendarContext();

  const { isMonday, calendarWeek, isToday, isInSelectedMonth } =
    getInformationForDay(day, monthDate.month);
  const dayClasses = getDaysStyle(isToday, isInSelectedMonth);

  const createFormUrl = buildCreateTerminUrl(day);

  return (
    <div className="hidden md:flex items-center px-1 justify-between group">
      <div className="flex items-center">
        {isMonday && (
          <span className="text-neutrals-700 text-xs">
            {t('general.date.calendarWeek')} {calendarWeek}
          </span>
        )}
      </div>
      <div className="flex gap-2">
        {termine.length > 0 && (
          <Link
            className={cn(
              buttonVariants({ variant: 'default', size: 'xs' }) +
                'h-6 w-6 hidden group-hover:flex',
            )}
            to={createFormUrl}>
            <FontAwesomeIcon icon={faPlusLarge} size="xs" />
          </Link>
        )}
        <span className={dayClasses}>{day.format('D')}</span>
      </div>
    </div>
  );
}
